import { Box, useColorModeValue } from "@chakra-ui/react";
import { IconButton } from "components";
import { MdNotifications } from "react-icons/md";
import { useAppStore } from "store/useAppStore";
import { byLook } from "theme/look";
import { TopBarColorMode } from "../../../../TopBarColorMode";
import { useUnreadCount } from "../../Notifications.hooks";

const NotificationIcon = ({ onClick }: { onClick: () => void }) => {
  const unreadCount = useUnreadCount();
  const impersonation = useAppStore.use.impersonation();
  const iconColor = byLook(
    useColorModeValue("gray.600", "gray.300"),
    "gray.300",
  );

  return (
    <Box>
      <TopBarColorMode>
        {!impersonation && (
          <IconButton
            size="sm"
            color={iconColor}
            tooltip={
              unreadCount > 0
                ? `You have unread notifications`
                : "You have no unread notifications"
            }
            icon={<MdNotifications size="24px" />}
            onClick={onClick}
            tooltipPlacement="bottom-end"
          />
        )}

        {impersonation && (
          <IconButton
            isDisabled
            size="sm"
            color={iconColor}
            tooltip="Notifications are not available while impersonating."
            icon={<MdNotifications size="24px" />}
            onClick={() => undefined}
            tooltipPlacement="bottom-end"
          />
        )}
      </TopBarColorMode>
    </Box>
  );
};

export { NotificationIcon };
